import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBar from '@/components/feature/MobileBar';
import { modalities } from '@/mocks/modalities';

export default function Modalidades() {
  const { t } = useTranslation();

  const title = t('seo.modalidades.title');
  const description = t('seo.modalidades.description');
  const keywords = t('seo.modalidades.keywords');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://topgym.com.br';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: title,
    description: description,
    url: `${siteUrl}/modalidades`,
    itemListElement: modalities.map((mod, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Thing',
        name: t(`modality.${mod.id}.name`),
        description: t(`modality.${mod.id}.description`),
        image: mod.image,
      },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: t('nav.home'),
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: t('page.modalidades.title'),
        item: `${siteUrl}/modalidades`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO title={title} description={description} keywords={keywords} path="/modalidades" schema={[schema, breadcrumbSchema]} />
      <Navbar />
      <main className="overflow-x-hidden pb-20 md:pb-0">
        <section className="bg-foreground-950 py-20 md:py-28">
          <div className="w-full px-4 md:px-6">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50">
              {t('page.modalidades.title')}
            </h1>
            <p className="font-body text-base text-background-300 mt-4 max-w-xl">
              {t('page.modalidades.subtitle')}
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {modalities.map((mod) => (
                <div key={mod.id} className="bg-background-100 rounded-lg overflow-hidden border border-background-200">
                  <div className="aspect-[16/9] w-full">
                    <img src={mod.image} alt={t(`modality.${mod.id}.name`)} loading="lazy" fetchPriority="low" width="800" height="450" decoding="async" className="w-full h-full object-cover" />
                  </div>
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 mb-2">
                      <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">{t(`modality.${mod.id}.name`)}</h2>
                      {mod.tag && (
                        <span className="bg-primary-500 text-foreground-950 font-body text-xs font-bold px-3 py-1 rounded-full">
                          {t('page.modalidades.tag')}
                        </span>
                      )}
                    </div>
                    <p className="font-body text-sm text-foreground-600 leading-relaxed">{t(`modality.${mod.id}.description`)}</p>
                    <p className="font-body text-xs text-primary-600 mt-3 font-medium">{t(`modality.${mod.id}.audience`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}